import { observer } from 'mobx-react-lite'
import { makeTextFieldIcon } from 'shared/ui/TextField'
import { EnrolmentStep } from 'widgets/ContactEnrollment'
import { useChatbotContext } from 'pages/chatbot/context'

export const StepEnrollment = observer(() => {
  const { enrollment, errors, model, numberId } = useChatbotContext()
  const enrollmentError = errors.getError('filters')
  const numberError = errors.getError('send_from') ?? ''
  const {
    enrollmentStore: {
      isContactReEnroll,
      setIsContactReEnroll,
      isShowContactsAlert,
      setIsShowContactsAlert,
    },
    editEnrollment,
    enrollmentFilters,
  } = enrollment

  const onClick = () => {
    editEnrollment()
    errors.removeError('filters')
  }

  return (
    <EnrolmentStep
      tooltipLabel={'Choose the conditions that trigger a conversation with your AI Agent'}
      title='Contact enrollment'
      enrollmentFilters={enrollmentFilters}
      removeError={() => errors.removeError('send_from')}
      numberError={numberError}
      numberStore={numberId.store}
      dropdownWidth={452}
      rightActions={[makeTextFieldIcon({ icon: 'chevronDown', fontSize: 18 })]}
      error={enrollmentError}
      onClick={onClick}
      contactReEnroll={{
        value: isContactReEnroll,
        onChange: (value) => {
          setIsContactReEnroll(value)
          model.settings.setAllowReEntering(value)
        },
        isShowAlert: isShowContactsAlert,
        onCloseAlert: () => setIsShowContactsAlert(false),
      }}
    />
  )
})
